<template>
    <h2 class="mt-2 mb-2 font-bold">Caractéristiques techniques du vélo</h2>
    <div class="border-2 border-grey rounded-lg p-2">
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.brand"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.brand',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.brand }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.model"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.model',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.model }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.motor"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.engine',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.motor }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.battery"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.battery',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.battery }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.display_device"
        >
            <p>Console :</p>
            <p>
                {{ bike?.display_device }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.transmission"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.transmission',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.transmission }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.cassette"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.cassette',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.cassette }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.brakes"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.brakes',
                    )
                }}
                :
            </p>
            <p>
                {{ bike?.brakes }}
            </p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.front_brakes_size"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.front-brake-size',
                    )
                }}
                :
            </p>
            <p>{{ bike?.front_brakes_size }} mm</p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.back_brakes_size"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.back-brake-size',
                    )
                }}
                :
            </p>
            <p>{{ bike?.back_brakes_size }} mm</p>
        </div>
        <div
            class="grid grid-cols-2 border-b-2 border-dotted border-bottom border-grey p-2"
            v-if="bike?.weight"
        >
            <p>
                {{
                    $translate(
                        'public.shop.home.bikes.card.details.techniques.weight',
                    )
                }}
                :
            </p>
            <p>{{ bike?.weight }} kgs</p>
        </div>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';
defineProps({
    bike: Object,
});
</script>
